import authReducer from "./authReducer";
import riskReducer from "./riskReducer";
import departmentReducer from "./departmentReducer";
import incidentReducer from "./incidentReducer";
import dashboardReducer from "./dashboardReducer";
import settingsReducer from "./settingsReducer";
import profileReducer from "./profileReducer";
import adminReducer from "./adminReducer";
import filesReducer from "./filesReducer";
import complianceReducer from "./complianceReducer";
import assetReducer from "./assetReducer";
import { combineReducers } from "redux";
import flowchartReducer from "./flowchartReducer";
import workflowAiReducer from "./workflowAiReducer";
import chatbotReducer from "./chatbotReducer";
import reportReducer from "./reportReducer";
import auditReducder from "./auditReducer"
import marketplaceReducer from "./marketplaceReducer"

const appReducer = combineReducers({
  //home: homeReducer,
  auth: authReducer,
  risk: riskReducer,
  department: departmentReducer,
  incident: incidentReducer,
  dashboard: dashboardReducer,
  settings: settingsReducer,
  profile: profileReducer,
  admin: adminReducer,
  files: filesReducer,
  compliance: complianceReducer,
  asset: assetReducer,
  workflows: flowchartReducer,
  workflowAi: workflowAiReducer,
  chatbot: chatbotReducer,
  reports: reportReducer,
  audits: auditReducder,
  marketplace: marketplaceReducer
});

// Every slice above is persisted (redux-persist has no whitelist/blacklist for
// this store), but only authReducer used to reset on logout — so re-logging in
// as a different user kept showing the previous user's profile/risks/dashboard
// data until each page's own fetch happened to overwrite it. Wiping the whole
// state back to its initial shape on logout means every reducer's default
// state kicks in, so the next login starts genuinely clean.
const rootReducer = (state, action) => {
  if (action.type === "LOG_USER_OUT") {
    state = undefined;
  }
  return appReducer(state, action);
};

export default rootReducer;
